<script>
	import ImageOptimiser from '$lib/components/common/ImageOptimiser.svelte';
	import dailyHero from '$vl/lib/assets/images/daily-salad-hero.png';
	import dailySaladImg1 from '$vl/lib/assets/images/salad-plan/daily-salad-img-1.png';
	import dailySaladImg2 from '$vl/lib/assets/images/salad-plan/daily-salad-img-2.png';

	// images
	import { getPlanMetadata } from '$lib/utils/plans-metadata';

	let mealSlot = [
		{
			name: `Vibrant Living's Salad Plan is more than just delicious meals. It's a commitment to:`,
			mealDescription:
				'Kickstart your day with a variety of wholesome options like Millet saddiannam, Jowar Rava upma, and Chia seed pudding, all packed with essenstial nutrients.',
			meal: [
				{
					src: dailySaladImg1,
					alt: 'pancakes',
					title: 'Freshness',
					itemDescription:
						'Each salad is made with the freshest seasonal ingredients, bursting with flavour and nutrients.'
				},
				{
					src: dailySaladImg2,
					alt: 'gunta punganal',
					title: 'Variety',
					itemDescription:
						'Say goodbye to salad monotony! Our chefs craft unique and exciting combinations each day, keeping your taste buds on a culinary adventure.'
				}
			]
		}
	];
</script>

<div class="bg-[#FEF1E4]">
	<div class="mx-4 max-w-[748px] py-10 md:mx-auto md:pt-[68px]">
		<div class="flex flex-col md:relative md:mx-auto md:max-w-[748px] md:flex-row">
			<div class="md:max-w-[519px]">
				<p class="font-roboto text-16 font-medium leading-7 text-[#F15922] md:text-20 md:leading-5">
					Vibrant Living’s
				</p>
				<h1
					class="font-playfair-display text-24 font-bold leading-8 text-[#362818] md:text-28 md:leading-9"
				>
					Daily Salad Lunch Plan
				</h1>
				<div class="mt-3">
					<h3 class="font-roboto text-16 font-medium leading-6 text-[#362818]">
						A Refreshing Reset, One Salad at a Time
					</h3>
					<p
						class="mt-1 font-roboto text-14 font-normal leading-5 text-[#362818] md:text-16 md:leading-7"
					>
						Looking for a lighter option? Our Daily Salad Plan provides you with fresh, delicious
						salads made from our finest ingredients.
					</p>
				</div>
				<div class="mt-8 flex gap-4">
					<a
						class="flex w-[208px] items-center justify-center rounded-3xl bg-[#F26B3A] px-4 py-3 font-roboto text-14 font-semibold leading-7 text-white shadow-2xl md:w-[224px] md:text-16 md:leading-6"
						href="/apex/plans/{getPlanMetadata('daily-salad-lunch-plan').id}/purchase"
						>Get Started</a
					>
				</div>
			</div>
			<div class="md:absolute md:right-[-126px] md:top-[-70px] md:h-[361px] md:w-[380px]">
				<img class="h-full w-full object-cover" src={dailyHero} alt="hero" />
			</div>
		</div>
		<div class="mt-4 md:mx-auto md:mt-16 md:max-w-[748px]">
			<p class="font-roboto text-14 font-normal leading-5 text-[#362818] md:text-16 md:leading-7">
				Each salad is packed with nutrients and comes with a variety of toppings and dressings to
				customize your taste. Perfect for a quick and healthy meal, this plan is a great way to
				boost your daily intake of fruits and vegetables.
			</p>
		</div>
	</div>
	<div class="mx-auto mt-9 flex max-w-[748px] flex-col gap-12 pb-10 lg:mt-[32px]">
		{#each mealSlot as slot}
			<div class="flex flex-col">
				<div>
					<h2
						class="mb:mx-0 mx-4 text-center font-roboto text-20 font-medium leading-7 text-[#362818] md:text-left md:text-28 md:leading-9"
					>
						{slot.name}
					</h2>
					<p
						class="mx-4 mt-1 text-center font-roboto text-14 font-normal leading-5 text-[#362818] md:mx-0 md:text-left md:text-16 md:leading-6"
					>
						{slot.mealDescription}
					</p>
				</div>
				<div
					class="mt-7 flex flex-col items-start justify-start gap-9 overflow-auto md:flex-row lg:gap-12"
				>
					{#each slot.meal as meal}
						<div class="mx-auto flex max-w-[350px] flex-1 flex-col items-center gap-3">
							<ImageOptimiser
								src={meal.src}
								alt={meal.alt}
								classes={{
									container: 'md:h-[282px] md:w-[350px] rounded-2xl',
									image: 'w-full h-full object-cover'
								}}
							/>
							<h3 class="font-roboto text-16 font-medium leading-6 text-[#362818]">
								{meal.title}
							</h3>
							<p
								class="font-roboto text-12 font-normal leading-4 text-[#362818] md:text-14 md:leading-5"
							>
								{meal.itemDescription}
							</p>
						</div>
					{/each}
				</div>
			</div>
		{/each}
	</div>
</div>
